// Globals
import { StyleProvider } from '@ant-design/cssinjs';
import * as Sentry from '@sentry/react';
import '@ant-design/v5-patch-for-react-19';
import { XProvider } from '@ant-design/x';
import { Spin } from 'antd';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { StyleSheetManager } from 'styled-components';

// Modules
import { WidgetContainer } from '@/modules/Widget';

// Components
import { StylesRootContainer } from './RootContainerStyles';

export const rootContainer = (containerElement: HTMLElement) => {
  const shadowRoot = containerElement.attachShadow({ mode: 'open' });
  const shadowContainer = document.createElement('div');
  shadowRoot.appendChild(shadowContainer);

  const root = createRoot(shadowContainer, {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  });

  root.render(
    <StyleProvider container={shadowRoot}>
      <StyleSheetManager target={shadowRoot}>
        <StylesRootContainer>
          <Suspense fallback={<Spin spinning />}>
            <XProvider>
              <WidgetContainer />
            </XProvider>
          </Suspense>
        </StylesRootContainer>
      </StyleSheetManager>
    </StyleProvider>
  );
};
